import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SkipLoginGuard } from '@colimo/colimo-ui-library';
import { LoginComponent } from './login.component';

const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
    canActivate: [SkipLoginGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LoginRoutingModule {}
